module.exports = __webpack_public_path__ + "static/segment-logo-e17bb9b2c7f8be53b9dedc3884df8b14.png";